import { render, staticRenderFns } from "./schedule2.vue?vue&type=template&id=05a91fb2&scoped=true"
import script from "./schedule2.vue?vue&type=script&lang=js"
export * from "./schedule2.vue?vue&type=script&lang=js"
import style0 from "./schedule2.vue?vue&type=style&index=0&id=05a91fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a91fb2",
  null
  
)

export default component.exports